class ShareService {
    cancelToken = {}

    constructor(axios) {
        this.axios = axios
    }

    async getSharePerformance(isin) {
        const url = `/api/shares/performance?isin=${isin}`;

        return await this
            .axios
            .get(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getShareQuotesPrice(isin, period, currency) {
        if (this.cancelToken.getShareQuotesPrice) {
            await this.cancelToken.getShareQuotesPrice.cancel();
        }

        const url = `/api/quotes/price/${isin}?period=${period}&currency=${currency}`;

        this.cancelToken.getShareQuotesPrice = this.axios.CancelToken.source();

        return await this
            .axios
            .get(url, { cancelToken: this.cancelToken.getShareQuotesPrice.token })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getSharePriceTargetConsensus(isin) {
        const url = `/api/shares/share-price-target-consensus/${isin}`;

        return await this
            .axios
            .get(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getShareGradeConsensus(isin) {
        const url = `/api/shares/share-grades-consensus/${isin}`;

        return await this
            .axios
            .get(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getShareFloat(isin) {
        const url = `/api/shares/share-float/${isin}`;

        return await this
            .axios
            .get(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    async getShareESGRiskRating(isin) {
        const url = `/api/shares/share-esg-risk-rating/${isin}`;

        return await this
            .axios
            .get(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            });
    }

    handleError(e) { 
        this.lastResponseCode = e.response?.status
        this.lastError = e.response?.statusText

        throw new Error(this.lastError)
    }
}

export default ShareService
